export default __webpack_public_path__ + "2c1156717875afe885294dbbe640a59e.svg";